// Styles
import './Checkbox.scss';
import React from "react";
import { ThemeContext } from "../theme/Theme";

interface CheckboxProps {
	name: string,
	value: string,
	checked: boolean,
	ariaDescription?: string,
	label: any,
	onChange: any,
	style?: any
}

function Checkbox(props: CheckboxProps) {
	const context = React.useContext(ThemeContext);

	const checkboxStyle = {
		color: context.themeManager.value('checkbox', 'color', 'fg-color-form-element'),
		selectedColor: context.themeManager.value('checkbox', 'selectedColor', 'fg-color-form-element'),
		hoverColor: context.themeManager.value('checkbox', 'hoverColor', 'border-color-form-element-focus'),
		backgroundColor: context.themeManager.value('checkbox', 'backgroundColor', 'bg-color-form-element'),
		borderColor: context.themeManager.value('checkbox', 'borderColor', 'border-color-form-element'),
		checkedBackgroundColor: context.themeManager.value('checkbox', 'checkedBackgroundColor', 'bg-color-form-element'),
		checkmarkColor: context.themeManager.value('checkbox', 'checkmarkColor', 'fg-color-form-element'),
		disabledColor: context.themeManager.value('checkbox', 'disabledColor', 'fg-color-text-disabled'),
		outlineColor: context.themeManager.value('checkbox', 'outlineColor', 'border-color-form-element-focus'),
	};

	const style: any = {
		input: {
			'--checkbox-background-color': checkboxStyle.backgroundColor,
			'--checkbox-border-color': checkboxStyle.borderColor,
			'--checkbox-hover-color': checkboxStyle.hoverColor,
			'--checkbox-checked-background-color': checkboxStyle.checkedBackgroundColor,
			'--checkbox-checkmark-color': checkboxStyle.checkmarkColor,
			'--checkbox-disabled-color': checkboxStyle.disabledColor,
			'--checkbox-outline-color': checkboxStyle.outlineColor,
		},
		label: {
			color: checkboxStyle.color,
		},
		checkedLabel: {
			color: checkboxStyle.selectedColor,
		},
	};

	const {
		name,
		value,
		onChange,
		checked,
		label,
	} = props;

	const randomId = parseInt(String(Math.random() * 100000), 10);

	return (
		<div className="checkbox__container" style={props.style}>
			<input
				className="checkbox__input"
				id={name + randomId}
				type="checkbox"
				name={name}
				value={value}
				checked={checked}
				onChange={onChange}
				style={style.input}
				{...(props.ariaDescription ? {'aria-description': props.ariaDescription} : {})}
			/>
			<label
				className="checkbox__label"
				htmlFor={name + randomId}
				style={checked ? style.checkedLabel : style.label}
			>{label}</label>
		</div>
	);
}

export default Checkbox;
